import React, { useEffect } from "react";
import Controls from "src/components/form/controls/Controls";
import useForm, { Form } from "src/hooks/useForm";
import { notContainsOnlySpaces, validationADBProvinceInput } from "src/utils";

const initialValue = {
  id: "",
  provinceName: "",
  provinceCode: 0,
};

const isDisableButton = (provinceName) => {
  return !notContainsOnlySpaces(provinceName);
};

function ProvinceForm(props) {
  const { addOrEdit, recordForEdit } = props;

  // validation input permission
  const validateADBProvinceForm = (fieldValues = values) => {
    let temp = validationADBProvinceInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateADBProvinceForm);

  const onSubmit = (e) => {
    e.preventDefault();

    if (validateADBProvinceForm()) {
      addOrEdit(values, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="provinceName"
        value={values.provinceName}
        label="Province Name"
        type="text"
        onChange={handleInputChange}
        error={errors.provinceName}
      />
      <Controls.Input
        name="provinceCode"
        value={values.provinceCode}
        label="Province Code"
        type="number"
        disabled={Boolean(recordForEdit)}
        onChange={handleInputChange}
        error={errors.provinceCode}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        // disabled={notContainsOnlySpaces(values.provinceName) ? false : true}
        disabled={isDisableButton(values.provinceName)}
      />
    </Form>
  );
}

export default ProvinceForm;
